var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "container" }, [
      _c("p", { staticClass: "block_" }, [
        _vm._v("นโยบายคุ้มครองข้อมูลส่วนบุคคล")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_" }, [_vm._v("บริษัท บีนีท จำกัด")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [_vm._v("ข้อมูลส่วนบุคคล คืออะไร?")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "ข้อมูลส่วนบุคคล หมายถึง ข้อมูลเกี่ยวกับบุคคลซึ่งทำให้สามารถระบุตัวตนบุคคลนั้นได้ ไม่ว่าทางตรงหรือทางอ้อม แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรมโดยเฉพาะ"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [
        _vm._v("ลักษณะข้อมูลส่วนบุคคลที่เราเก็บรวบรวม")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("เราจะเก็บรวบรวมข้อมูลส่วนบุคคลดังต่อไปนี้")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v("1 ข้อมูลที่บ่งชี้ตัวตน อาทิ ชื่อ อายุ สัญชาติ วันเกิด อายุ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 ข้อมูลช่องทางการติดต่อ อาทิ ที่อยู่ สถานที่ติดต่อ เบอร์โทร อีเมล"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("3 ข้อมูลบัญชี อาทิ รายละเอียดการชำระเงิน และบัญชีธนาคาร")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "4 ข้อมูลทางธุรกรรม อาทิ ประวัติการรับบริการต่างๆ ประวัติการซื้อขาย"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "5 ข้อมูลส่วนตัว อาทิ ชื่อบัญชีผู้ใช้ รหัสผ่าน การสั่งซื้อ ความสนใจของท่านที่มีต่อบริการต่างๆของผู้ให้บริการ"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "6 ข้อมูลทางเทคนิค อาทิ Google Analytics หมายเลขระบุตำแหน่งคอมพิวเตอร์ (IP Address) ข้อมูลการเข้าระบบ ข้อมูลการใช้งาน และ การตั้งค่า (log)"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "7 ข้อมูลทางการตลาด อาทิ ความพึงพอใจของท่านต่อบริการที่ได้รับ และความเห็นต่อการให้บริการของบุคลากร"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [_vm._v("8 รูปภาพ")]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "9 ข้อมูลตำแหน่งของผู้ใช้แบบเบื้องหลังในระหว่างการเดินทางไปให้บริการ (เฉพาะผู้ให้บริการที่ใช้แอพ BeNeat Cleaner)"
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [
        _vm._v("แหล่งที่มาของข้อมูลส่วนบุคคล")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("เราได้รับข้อมูลส่วนบุคคลของท่านจาก 2 ช่องทาง ดังนี้")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "1 เราได้รับข้อมูลส่วนบุคคลจากท่านโดยตรง โดยเราจะเก็บรวบรวมข้อมูลส่วนบุคคลของท่านจากขั้นตอนการให้บริการดังนี้"
          )
        ])
      ]),
      _vm._v(" "),
      _c("ol", { staticClass: "list_" }, [
        _c("li", { staticClass: "block_4" }, [
          _vm._v(
            "เมื่อท่านลงทะเบียนบัญชีเพื่อใช้บริการกับเรา หรือเมื่อท่านยื่นคำร้องขอใช้สิทธิต่างๆ กับเรา"
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v("เมื่อท่านสมัครรับข้อมูลสื่อโฆษณาหรือข้อมูลด้านการตลาดจากเรา")
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v("จากความสมัครใจของท่านในการทำแบบสอบถาม")
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v("จากการเก็บข้อมูลการใช้แพลตฟอร์มของท่านผ่านบราวเซอร์คุกกี้")
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v(
            "จากการติดต่อสอบถามของท่าน หรือผ่านการโต้ตอบทางอีเมลหรือ ช่องทางการสื่อสารอื่นๆ เช่น โทรศัพท์ เพื่อที่ผู้ให้บริการสามารถติดต่อท่านกลับได้"
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v("เมื่อท่านกดซื้อบริการหรือผลิตภัณฑ์จากเรา")
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v(
            "เมื่อท่านเข้าสู่ระบบบัญชีผู้ใช้บนแพลตฟอร์มของเรา หรือแอพพลิเคชั่นอื่นๆที่เกี่ยวข้อง อาทิ เฟสบุ๊ค และ กูเกิ้ล"
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v(
            "เมื่อท่านกดปุ่มออกเดินทางในแอพ BeNeat Cleaner โดยระบบจะเก็บข้อมูลตำแหน่งผู้ใช้แบบเบื้องหลังทุก ๆ 15 นาที โดยเริ่มตั้งการออกเดินทาง และสิ้นสุดเมื่อผู้ให้บริการได้ยืนยันการเช็คอินเข้าที่พักของลูกค้า"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 เราได้รับข้อมูลส่วนบุคคลของท่านมาจากบุคคลที่สาม ดังต่อไปนี้ Facebook Login, Google Login, LINE Login, Email & Password Login โดยได้รับข้อมูลเมื่อท่านสมัครระบบหรือเข้าใช้งานระบบผ่านช่องทางของบุคคลที่สาม"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "block_3" }, [
        _vm._v("ในส่วนของข้อมูลตำแหน่งของผู้ใช้ ")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [
        _vm._v("วัตถุประสงค์ในการประมวลผลข้อมูล")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "1 เราจัดเก็บข้อมูลส่วนบุคคลของท่านเพื่อประโยชน์ในการจัดฐานข้อมูลในการวิเคราะห์ และเสนอสิทธิประโยชน์ตามความสนใจของท่าน"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 เราจัดเก็บข้อมูลส่วนบุคคลของท่านเพื่อการดำเนินการชำระเงินค่าบริการหรือสินค้าที่ท่านซื้อในระบบ"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "3 เราจัดเก็บข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ในการรับข้อมูลหลังการบริการ เช่น การสอบถามข้อมูล การแสดงความคิดเห็นหลังการบริการ หรือ การส่งคำร้องแก่ผู้ให้บริการ เป็นต้น"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "4 เราจัดเก็บข้อมูลส่วนบุคคลเพื่อยืนยันตัวตนว่าท่านเป็นผู้เดียวในการเข้าถึงบัญชีของท่าน"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("5 "),
          _c("span", { staticClass: "calibre2" }, [
            _vm._v(
              "เราจัดเก็บข้อมูลส่วนบุคคลของท่านเพื่อวิจัยการตลาดและบริหารความสัมพันธ์ระหว่างผู้  ให้บริการและผู้ใช้บริการ"
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "6 เราจัดเก็บข้อมูลส่วนบุคคลของท่านเพื่อปฏิบัติตามข้อกฎหมาย และระเบียบบังคับใช้ของรัฐ"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "7 เราจัดเก็บข้อมูลส่วนบุคคลของท่านเพื่อปฏิบัติตามกฎระเบียบที่ใช้บังคับกับผู้บริการ รวมถึงการยินยอมให้ผู้ให้บริการสามารถโอนข้อมูลส่วนบุคคลให้แก่กลุ่มธุรกิจและพันธมิตรของผู้ให้บริการ ผู้ประมวลผลข้อมูล หรือหน่วยงานใดๆที่มีสัญญากับผู้ให้บริการ"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "8 เราจัดเก็บจัดเก็บข้อมูลตำแหน่งของผู้ใช้แบบเบื้องหลัง เพื่อประโยชน์กับผู้ที่จองบริการในแง่ของการประเมินเวลา และระยะทางที่กำลังจะมาถึงของผู้ให้บริการ หรือช่วยบอกเส้นทางในกรณีที่ผู้ให้บริการหลงทาง"
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [
        _vm._v("การประมวลผลข้อมูลส่วนบุคคล")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("เมื่อได้รับข้อมูลส่วนบุคคลจากท่านแล้ว เราจะดำเนินการดังนี้")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "1 เก็บรวบรวมโดยมีการบันทึกในระบบคอมพิวเตอร์ ที่ใช้บริการ ได้แก่ Amazon AWS, Digital Ocean"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            '2 เราจะใช้ข้อมูลส่วนบุคคลของท่านที่ได้เก็บรวบรวมมาในการดำเนินของบริษัทตามวัตถุประสงค์ที่ระบุไว้ในหัวข้อ "วัตถุประสงค์ในการประมวลผลข้อมูล"'
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "3 บริษัทจะเปิดเผยข้อมูลกับพนักงานภายใต้สัญญาจ้างของบริษัทที่มีขอบเขตหน้าที่เกี่ยวข้องกับข้อมูล เปิดเผยบนแพลตฟอร์มของบริษัท หรือช่องทางสังคมออนไลน์เพื่อการโฆษณา นอกจากนี้ เราอาจจำเป็นต้องส่งข้อมูลส่วนบุคคลของท่านไปยังหน่วยงานข้อมูลเครดิต เพื่อตรวจสอบ และอาจใช้ผลการตรวจสอบข้อมูลดังกล่าวเพื่อการป้องกันการฉ้อโกง"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "4 บริษัทจะเปิดเผยข้อมูลตำแหน่งของผู้ให้บริการแบบเบื้องหลัง ให้เฉพาะผู้ใช้บริการที่เป็นเจ้าของการจอง และทีมปฏิบัติการของบีนีทเท่านั้น"
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [
        _vm._v("การเก็บรักษาและระยะเวลาในการเก็บรักษาข้อมูลส่วนบุคคล")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_5" }, [
        _vm._v("การเก็บรักษาข้อมูลส่วนบุคคล")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("ผู้ควบคุมทำการเก็บรักษาข้อมูลส่วนบุคคลของท่าน ดังนี้")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "1 ข้อมูลส่วนบุคคลที่ทางบริษัทจัดเก็บจะอยู่ในลักษณะของ Hard Copy, Soft Copy"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 ข้อมูลส่วนบุคคลจะถูกจัดเก็บไว้ในเครื่องมืออุปกรณ์ของบริษัท ได้แก่ คอมพิวเตอร์ โทรศัพท์มือถือ ของทางบริษัท รวมถึงมีการเก็บข้อมูลในบนระบบคอมพิวเตอร์ ซึ่งได้แก่ Amazon AWS, Digital Ocean"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            '3 ระยะเวลาจัดเก็บ เป็นไปตามหัวข้อ "ระยะเวลาในการประมวลผลข้อมูลส่วนบุคคล"'
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [_vm._v("Data Retention Period")]),
      _vm._v(" "),
      _c("table", { staticClass: "table_" }, [
        _c("tbody", { staticClass: "calibre3" }, [
          _c("tr", { staticClass: "calibre4" }, [
            _c("td", { staticClass: "td_" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("ลำดับที่")])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_1" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("ประเภท / รายการข้อมูลส่วนบุคคล")
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_2" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("ระยะเวลาประมวลผล")])
            ])
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "calibre4" }, [
            _c("td", { staticClass: "td_3" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("1.")])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_4" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v(
                  "ข้อมูลที่บ่งชี้ตัวตน อาทิ ชื่อ อายุ สัญชาติ วันเกิด อายุ"
                )
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_5" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("10 ปี นับแต่วันที่เลิกสัญญา")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "calibre4" }, [
            _c("td", { staticClass: "td_3" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("2.")])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_4" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v(
                  "ข้อมูลช่องทางการติดต่อ อาทิ ที่อยู่ สถานที่ติดต่อ เบอร์โทร อีเมล"
                )
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_5" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("10 ปี นับแต่วันที่เลิกสัญญา")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "calibre4" }, [
            _c("td", { staticClass: "td_3" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("3.")])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_4" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("ข้อมูลบัญชี อาทิ รายละเอียดการชำระเงิน และบัญชีธนาคาร")
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_5" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("10 ปี นับแต่วันที่เลิกสัญญา")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "calibre4" }, [
            _c("td", { staticClass: "td_3" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("4.")])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_4" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v(
                  "ข้อมูลทางธุรกรรม อาทิ ประวัติการรับบริการต่างๆ ประวัติการซื้อขาย"
                )
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_5" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("10 ปี นับแต่วันที่เลิกสัญญา")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "calibre4" }, [
            _c("td", { staticClass: "td_3" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("5.")])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_4" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v(
                  "ข้อมูลส่วนตัว อาทิ ชื่อบัญชีผู้ใช้ รหัสผ่าน การสั่งซื้อ ความสนใจของท่านที่มีต่อบริการต่างๆของผู้ให้บริการ"
                )
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_5" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("5 ปี นับแต่วันที่เลิกสัญญา")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "calibre4" }, [
            _c("td", { staticClass: "td_3" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("6.")])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_4" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v(
                  "ข้อมูลทางเทคนิค อาทิ Google Analytics หมายเลขระบุตำแหน่งคอมพิวเตอร์ (IP Address) ข้อมูลการเข้าระบบ ข้อมูลการใช้งาน และ การตั้งค่า (log)"
                )
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_5" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("5 ปี นับแต่วันที่เลิกสัญญา")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "calibre4" }, [
            _c("td", { staticClass: "td_3" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("7.")])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_4" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v(
                  "ข้อมูลทางการตลาด อาทิ ความพึงพอใจของท่านต่อบริการที่ได้รับ และความเห็นต่อการให้บริการของบุคลากร"
                )
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_5" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("5 ปี นับแต่วันที่เลิกสัญญา")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "calibre4" }, [
            _c("td", { staticClass: "td_6" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("8.")])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_7" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("รูปภาพ")])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_8" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("5 ปี นับแต่วันที่เลิกสัญญา")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", { staticClass: "calibre4" }, [
            _c("td", { staticClass: "td_6" }, [
              _c("p", { staticClass: "block_1" }, [_vm._v("9.")])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_7" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("ข้อมูลตำแหน่งของผู้ใช้แบบเบื้องหลัง")
              ])
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "td_8" }, [
              _c("p", { staticClass: "block_1" }, [
                _vm._v("5 ปี นับแต่วันที่เลิกสัญญา")
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [_vm._v("สิทธิของเจ้าของข้อมูล")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("ท่านมีสิทธิในการดำเนินการ ดังต่อไปนี้")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "1 สิทธิในการได้รับแจ้ง (right to be informed): ท่านมีสิทธิที่จะได้รับแจ้งเมื่อข้อมูลส่วนบุคคลของท่านถูกจัดเก็บ รวมถึงรายละเอียดต่างๆที่เกี่ยวข้อง อาทิ วิธีการจัดเก็บและระยะเวลาการจัดเก็บ"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 สิทธิในการเพิกถอนความยินยอม (right to withdraw consent): ท่านมีสิทธิในการเพิกถอนความยินยอมในการประมวลผลข้อมูลส่วนบุคคลที่ท่านได้ให้ความยินยอมกับเราได้ ตลอดระยะเวลาที่ข้อมูลส่วนบุคคลของท่านอยู่กับเรา"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "3 สิทธิในการเข้าถึงข้อมูลส่วนบุคคล (right of access): ท่านมีสิทธิในการเข้าถึงข้อมูลส่วนบุคคลของท่านและขอให้เราทำสำเนาข้อมูลส่วนบุคคลดังกล่าวให้แก่ท่าน รวมถึงขอให้เราเปิดเผยการได้มาซึ่งข้อมูลส่วนบุคคลที่ท่านไม่ได้ให้ความยินยอมต่อเรา"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "4 สิทธิในการแก้ไขข้อมูลส่วนบุคคลให้ถูกต้อง (right to rectification): ท่านมีสิทธิในการขอให้เราแก้ไขข้อมูลที่ไม่ถูกต้องหรือเพิ่มเติมข้อมูลที่ไม่สมบูรณ์"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "5 สิทธิในการลบข้อมูลส่วนบุคคล (right to erasure): ท่านมีสิทธิในการขอให้เราทำการลบข้อมูลของท่านด้วยเหตุบางประการได้ "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "6 สิทธิในการระงับการใช้ข้อมูลส่วนบุคคล (right to restriction of processing): ท่านมีสิทธิในการระงับการใช้ข้อมูลส่วนบุคคลของท่านด้วยเหตุบางประการได้"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "7 สิทธิในการให้โอนย้ายข้อมูลส่วนบุคคล (right to data portability): ท่านมีสิทธิในการโอนย้ายข้อมูลส่วนบุคคลของท่านไปให้แก่ผู้ควบคุมข้อมูลรายอื่นหรือตัวท่านเองด้วยเหตุบางประการได้"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "8 สิทธิในการคัดค้านการประมวลผลข้อมูลส่วนบุคคล (right to object): ท่านมีสิทธิในการคัดค้านการประมวลผลข้อมูลส่วนบุคคลของท่านด้วยเหตุบางประการได้"
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "ท่านสามารถติดต่อมายังเจ้าหน้าที่ DPO หรือเจ้าหน้าที่ฝ่ายควบคุมข้อมูลของเราได้ เพื่อดำเนินการยื่นคำร้องขอดำเนินการตามสิทธิข้างต้นได้ (รายละเอียดการติดต่อปรากฏในหัวข้อ “ช่องทางการติดต่อ” ด้านล่างนี้) หรือ ท่านสามารถศึกษารายละเอียดเงื่อนไข ข้อยกเว้นการใช้สิทธิต่างๆ ได้ที่ แนวปฏิบัติเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคล (TDPG2.0) และ เว็บไซต์กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม http://www.mdes.go.th"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "ทั้งนี้ ท่านไม่จำเป็นต้องเสียค่าใช้จ่ายใดๆ ในการดำเนินตามสิทธิข้างต้น โดยเราจะพิจารณา และแจ้งผลการพิจารณาคำร้องของท่านภายใน 30 วันนับแต่วันที่เราได้รับคำร้องขอดังกล่าว"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [
        _vm._v("การยื่นคำร้องเพื่อการจัดการข้อมูลส่วนบุคคล")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          'หากท่านมีความประสงค์ในการยื่นคำร้องเรียนเพื่อจัดการข้อมูลส่วนบุคคลของท่าน ซึ่งรวมไปถึงการขอเข้าถึงข้อมูลส่วนบุคคล การแก้ไขข้อมูลส่วนบุคคล การขอเพิกถอนการยินยอมให้ข้อมูลส่วนบุคคล และการส่งความคิดเห็นต่อการบริการ ท่านสามารถติดต่อได้ทางเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลตามรายละเอียดในหัวข้อ "ช่องทางการติดต่อ"'
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [_vm._v("กิจกรรมส่งเสริมการตลาด")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "ในระหว่างการใช้บริการ เราจะส่งข้อมูลข่าวสารเกี่ยวกับกิจกรรมทางการตลาด และการส่งเสริม การตลาด ผลิตภัณฑ์ การให้บริการ ที่เราคิดว่าท่านอาจสนใจเพื่อประโยชน์ในการให้บริการกับ ท่านอย่างเต็มประสิทธิภาพ หากท่านได้ตกลงที่จะรับข้อมูลข่าวสารดังกล่าวจากเราแล้ว ท่านมีสิทธิ ยกเลิกความยินยอมดังกล่าวได้ทุกเมื่อ โดยท่านสามารดำเนินการยกเลิกความยินยอมในการรับแจ้งข้อมูล ข่าวสารได้โดยสามารถติดต่อมาได้ผ่านทางที่อยู่อีเมล Info@beneat.co"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [_vm._v("Cookies คืออะไร?")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "Cookies คือ text files ที่อยู่ในคอมพิวเตอร์ของท่าน ใช้เพื่อจัดเก็บรายละเอียดข้อมูล log การใช้งานอินเตอร์เน็ตของท่าน หรือ พฤติกรรมการเยี่ยมชมเว็บไซต์ของท่าน ท่านสามารถศึกษารายละเอียด เพิ่มเติมของ Cookies ได้จาก https://www.allaboutcookies.org/"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [_vm._v("เราใช้ Cookies อย่างไร?")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "เราจะจัดเก็บข้อมูลการเข้าเยี่ยมชมเว็บไซต์จากผู้เข้าเยี่ยมชมทุกรายผ่าน Cookies หรือ เทคโนโลยีที่ใกล้เคียง และเราใช้ Cookies เพื่อประโยชน์ในการพัฒนาประสิทธิภาพในการเข้าถึงบริการของเราผ่านระบบอินเตอร์เน็ต รวมถึงพัฒนาประสิทธิภาพในการใช้งานแพลตฟอร์ม โดยจะใช้เพื่อกรณี ดังต่อไปนี้"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "1 เพื่อให้ท่านสามารถเข้าสู่ระบบบัญชีของท่านในแพลตฟอร์มของเราได้อย่างต่อเนื่อง และปลอดภัย"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 เพื่อบันทึกข้อมูลการใช้งานบนแพลตฟอร์มของท่าน จัดเนื้อหาข้อมูล รวมถึงรูปแบบแพลตฟอร์มที่ท่านได้ตั้งค่าไว้"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "3 เพื่อศึกษาพฤติกรรมการใช้งานและเยี่ยมชมแพลตฟอร์มของท่าน เพื่อปรับเนื้อหาให้ตรงกับความสนใจ และสามารถตอบสนองความต้องการของท่านมากขึ้น"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "4 เพื่อศึกษาพฤติกรรมของผู้เยี่ยมชมแพลตฟอร์มโดยรวม และนำไปพัฒนาให้สามารถใช้งานได้ง่าย รวดเร็ว และมีประสิทธิภาพยิ่งขึ้น"
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [
        _vm._v("ประเภทของ Cookies ที่เราใช้")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("เว็บไซต์ของเราประกอบไปด้วย Cookies ดังต่อไปนี้")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "1 Functionality Cookies: คุกกี้ประกอบการทำงานของแพลตฟอร์ม ถูกใช้ในการจดจำสิ่งที่ท่านเลือกหรือตั้งค่าบนแพลตฟอร์ม รวมถึงการนำเสนอข้อมูลที่ตรงความต้องการ เฉพาะบุคคลมากขึ้น เช่น ชื่อบัญชีผู้ใช้ ภาษา ฟ้อนต์ และรูปแบบแพลตฟอร์ม"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 Advertising Cookies: คุกกี้สำหรับการโฆษณา ใช้ในการจดจำสิ่งที่ท่านเคยเยี่ยมชมและรวมถึงลักษณะการใช้แพลตฟอร์มของท่าน เพื่อนำเสนอสินค้า บริการ หรือ สื่อโฆษณาที่เกี่ยวข้องและตรงกับความสนใจของท่าน และใช้เพื่อการประเมินประสิทธิผลของแคมเปญโฆษณาต่างๆ"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "3 Strictly Necessary Cookies: คุกกี้ทางเทคนิค เป็นประเภทคุกกี้ที่มีความจำเป็นต่อการใช้งานแพลตฟอร์ม ทำให้ท่านสามารถเข้าถึงข้อมูลได้อย่างทั่วถึงและปลอดภัย"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "4 Performance Cookies: คุกกี้เพื่อวัดผลการทำงานของแพลตฟอร์ม คุกกี้ประเภทนี้จะจัดเก็บข้อมูลของผู้เข้าชมแพลตฟอร์มแบบไม่ระบุตัวตน และนำมาวิเคราะห์จำนวนและพฤติกรรมของผู้เข้าชม เพื่อปรับปรุงแพลตฟอร์มให้มีประสิทธิภาพและตรงกับความต้องการของผู้ใช้มากขึ้น"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "5 Third-party Cookies: คุกกี้บุคคลที่สาม คุกกี้ชนิดนี้จะถูกกำหนดใช้โดยผู้บริการซึ่งเป็นบุคคลที่สาม อาทิ Google Analytics"
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [_vm._v("การตั้งค่าคุกกี้")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "ท่านสามารถตั้งค่าเพื่อปฏิเสธการใช้การคุกกี้ในบราวเซอร์ของท่านได้ โดยมีขั้นตอนในการจัดการดังนี้:"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_5" }, [
        _vm._v("สำหรับผู้ใช้ระบบซาฟารี (Safari)")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v("1 เข้าแอพพลิเคชั่นซาฟารีและเลือก “การตั้งค่า”")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 เลือก “ความเป็นส่วนตัว” และจัดการข้อมูลการใช้คุกกี้ตามความต้องการของท่านดังนี้"
          )
        ])
      ]),
      _vm._v(" "),
      _c("ol", { staticClass: "list_" }, [
        _c("li", { staticClass: "block_4" }, [
          _vm._v(
            "เลือก “ป้องกันไม่ให้ติดตามข้ามไซต์” เพื่อยกเลิกตัวติดตามใช้คุกกี้และข้อมูลเว็บไซต์"
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v(
            "เลือก “ปิดกั้นคุกกี้ทั้งหมด” เพื่อปิดกั้นไม่ให้เว็บไซต์บุคคลที่สามและผู้โฆษณาจัดเก็บข้อมูลต่างๆไว้บนเครื่องคอมพิวเตอร์ของคุณ"
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v(
            "เลือก “จัดการข้อมูลเว็บไซต์” เพื่อดูว่าเว็บไซต์ใดบ้างที่จัดเก็บคุกกี้และข้อมูลของท่าน"
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_5" }, [
        _vm._v("สำหรับผู้ใช้กูเกิ้ลโครม (Google Chrome)")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "1 เข้าระบบกูเกิ้ลโครมในคอมพิวเตอร์ และเลือก “การตั้งค่า” ด้านขวาบน"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("2 เลือก “ขั้นสูง” ด้านล่าง")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("3 เลือก “การตั้งค่าและความปลอดภัย”")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("4 เลือก “การตั้งค่าเว็บไซต์”")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [_vm._v("5 คลิก “คุกกี้”")]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "6 หากต้องการยกเลิกการใช้คุกกี้ เลือก “ปิดการอนุญาตให้เว็บไซต์บันทึกและอ่านข้อมูลคุกกี้”"
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_5" }, [
        _vm._v("สำหรับผู้ใช้ Internet Explorer")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v("1 เมื่อเข้าระบบ Internet Explorer เลือก “การตั้งค่า”")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("2 หากต้องการลบข้อมูลคุกกี้:")
        ])
      ]),
      _vm._v(" "),
      _c("ol", { staticClass: "list_" }, [
        _c("li", { staticClass: "block_4" }, [_vm._v("เลือก “ความปลอดภัย”")]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v("เลือก “ลบประวัติการเรียกดู”")
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v("เลือก “คุกกี้และข้อมูลเว็บไซต์” และกด “ลบ”")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v("3 หากต้องการลบข้อมูลคุกกี้:")
        ])
      ]),
      _vm._v(" "),
      _c("ol", { staticClass: "list_" }, [
        _c("li", { staticClass: "block_4" }, [_vm._v("เลือก “เครื่องมือ”")]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v("เลือก “ตัวเลือกอินเทอร์เน็ต”")
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v("เลือก “ความเป็นส่วนตัว”")
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "block_4" }, [
          _vm._v("กด “ขั้นสูง” และเลือกให้อนุญาตหรือบล็อกคุกกี้")
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [
        _vm._v("นโยบายคุ้มครองข้อมูลส่วนบุคคลของเว็บไซต์อื่น")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "นโยบายความเป็นส่วนตัวฉบับนี้ ใช้เฉพาะสำหรับการให้บริการของเราและการใช้งานเว็บไซต์ของเราเท่านั้น หากท่านได้กดลิงก์ก์ไปยังเว็บไซต์อื่น แม้จะผ่านช่องทางในเว็บไซต์ของเราก็ตาม ท่านจะต้องศึกษาและปฏิบัติตามนโยบายความเป็นส่วนตัวที่ปรากฏในเว็บไซต์นั้นๆ แยกจากของเว็บไซต์ของเราอย่างสิ้นเชิง"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [
        _vm._v("การเปลี่ยนแปลงนโยบายคุ้มครองข้อมูลส่วนบุคคล")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "เราจะทำการพิจารณาทบทวนนโยบายความเป็นส่วนตัวเป็นประจำเพื่อให้สอดคล้องกับแนวทางการปฏิบัติ และกฎหมายข้อบังคับที่เกี่ยวข้อง ทั้งนี้หากมีการเปลี่ยนแปลงนโยบายความเป็นส่วนตัว เราจะแจ้งให้ท่านทราบด้วยการปรับเปลี่ยนข้อมูลลงในเว็บไซต์ของเราโดยเร็วที่สุด ปัจจุบันนโยบายความเป็นส่วนตัวถูกทบทวนครั้งล่าสุดเมื่อ 11/05/2020 และจะมีผลตั้งแต่วันที่ 11/05/2020"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [_vm._v("ช่องทางการติดต่อ")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_5" }, [
        _vm._v("รายละเอียดผู้ควบคุมข้อมูล")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [_vm._v("ชื่อ: บริษัท บีนีท จำกัด")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "สถานที่ติดต่อ: 168/19 ม.7 ต.สันผีเสื้อ อ.เมือง จ.เชียงใหม่ 50300"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("ช่องทางการติดต่อ: 02 113 1138")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [_vm._v("อีเมล: Info@beneat.co")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [_vm._v("เว็บไซต์: www.BeNeat.co")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_5" }, [
        _vm._v(
          "รายละเอียดเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล (Data Protection Officer: DPO)"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [_vm._v("ชื่อ: คมคิด ชัชราภรณ์")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "สถานที่ติดต่อ: 168/19 ม.7 ต.สันผีเสื้อ อ.เมือง จ.เชียงใหม่ 50300"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("ช่องทางการติดต่อ: 0865857584")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("อีเมล: komkid.c@beneat.co")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_5" }, [
        _vm._v("รายละเอียดหน่วยงานกำกับดูแล")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "ในกรณีที่พนักงานของเราหรือบุคคลที่เกี่ยวข้องฝ่าฝืนหรือไม่ปฏิบัติตามกฎหมายเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคล ท่านสามารถร้องเรียนต่อหน่วยงานกำกับดูแลตามรายละเอียดดังนี้"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("ชื่อ: สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "สถานที่ติดต่อ: ชั้น 7 อาคารรัฐประศาสนภักดี ศูนย์ราชการ เฉลิมพระเกียรติ 80 พรรษาฯ ถนนแจ้งวัฒนะ แขวงทุ่งสองห้อง เขตหลักสี่ กรุงเทพมหานคร 10210"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("ช่องทางการติดต่อ: (+66) 02-142-2233")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [_vm._v(" ")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_6" }, [
        _vm._v("เอกสารแจ้งข้อมูลการประมวลผลข้อมูล (แบบย่อ)")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [
        _vm._v("ข้อมูลส่วนบุคคลที่จะทำการประมวลผล")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "รายละเอียดปรากฏตามนโยบายคุ้มครองข้อมูลส่วนบุคคล หัวข้อ “ข้อมูลส่วนบุคคลที่เราเก็บรวบรวม” และ “ระยะเวลาในการเก็บรักษาข้อมูลส่วนบุคคล” วัตถุประสงค์และฐานในการประมวลผลข้อมูล รายละเอียดปรากฏตามนโยบายคุ้มครองข้อมูลส่วนบุคคล หัวข้อ “วัตถุประสงค์ในการประมวลผลข้อมูล” เราดำเนินการประมวลผลข้อมูลส่วนบุคคลของท่านภายใต้ฐาน ดังต่อไปนี้"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "1 การปฏิบัติตามสัญญา ได้แก่ การจัดส่งใบเสร็จให้ผู้ใช้งานทางที่อยู่อีเมลภายหลังการซื้อบริการจากทางบริษัท หรือการโอนเงินไปยังบัญชีธนาคารของผู้ใช้ และสัญญาอื่นที่ทางเจ้าของข้อมูลส่วนบุคคลได้ทำไว้กับทางบริษัท"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("2 "),
          _c("span", { staticClass: "calibre2" }, [
            _vm._v(
              "ความยินยอม ตามที่ท่านได้ให้ความยินยอมเมื่อสมัครใช้บริการ ทั้งนี้หากท่านประสงค์จะถอนความยินยอม ท่านสามารถดำเนินการได้ดังนี้\nท่านสามารถแจ้งเพิกถอนความยินยอมในการให้ใช้หรือเปิดเผยข้อมูลในวัตถุประสงค์หรือลักษณะใดๆที่ได้ระบุไว้ข้างต้นได้ตลอดเวลา รวมถึงการร้องขอให้ลบหรือทำให้ข้อมูลส่วนบุคคลเป็นนิรนามได้ โดยติดต่อเจ้าหน้าที่ป้องกันข้อมูลส่วนบุคคลซึ่งระบุเอาไว้ด้านบน แนวทางการถอนความยินยอมประกอบไปด้วย:"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre5" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v("○ ช่องทางอิเล็กทรอนิกส์ อาทิ อีเมล หรือ เว็บไซต์")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("○ แจ้งผ่านวาจา อาทิ โทรศัพท์ หรือ ต่อหน้าบุคลากร")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("○ แจ้งผ่านลายลักษณ์อักษร")
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "โดยเมื่อบุคลากรได้รับคำรองของท่านแล้ว จะทำการส่งต่อให้แก่ฝ่ายบริหารจัดการข้อมูลเพื่อดำเนินการในขั้นตอนต่อไป"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "ทั้งนี้ทางผู้ให้บริการไม่สามารถเก็บข้อมูลส่วนบุคคลของท่านหากไม่ได้รับการยินยอม เว้นแต่เพื่อวัตถุประสงค์ต่อไปนี้"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "1 เพื่อผลประโยชน์สำคัญจำเป็น เพื่อระงับหรือป้องกันอันตรายต่อชีวิต สุขภาพ หรือร่างกายของบุคคล"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 เพื่อจัดทำเอกสารทางประวัติศาสตร์ จดหมายเหตุ การวิจัยหรือสถิติ"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "3 เพื่อการปฎิบัติตามพันธะสัญญาซึ่งเจ้าของข้อมูลส่วนบุคคลเป็นคู่สัญญา"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "4 เพื่อดำเนินงานตามระเบียบหรือกฎหมายของภาครัฐ หรือการใช้อำนาจรัฐของผู้ควบคุมส่วนบุคคล"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "5 เพื่อประโยชน์โดยชอบด้วยกฎหมายของผู้ให้บริการ ผู้ควบคุมข้อมูลส่วนบุคคล หรือนิติบุคคลอื่น เว้นแต้ประโยชน์ดังกล่าวมีความสำคัญน้อยกว่าสิทธิขั้นพื้นฐานในการให้ข้อมูลส่วนบุคคล"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("6 เพื่อประโยชน์สาธารณะของผู้ควบคุมข้อมูลส่วนบุคคล")
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [
        _vm._v("แหล่งที่มาของข้อมูลส่วนบุคคล")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v("เราได้รับข้อมูลส่วนบุคคลของท่าน จากกรณีดังนี้")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "calibre1" }, [
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "1 เมื่อท่านได้เข้าถึงหรือใช้บริการเว็บไซต์ของเรา ลงทะเบียน หรือสมัครบัญชีผู้ใช้กับเรา"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "2 เมื่อท่านส่งแบบฟอร์ม รวมถึงแบบฟอร์มการสมัครหรือแบบฟอร์มอื่นๆ ที่เกี่ยวข้องกับผลิตภัณฑ์และบริการของเรา ไม่ว่าจะเป็นรูปแบบออนไลน์หรือรูปแบบเอกสาร"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "3 เมื่อท่านทำข้อตกลงใดๆ หรือให้เอกสารหรือข้อมูลอื่นใดที่เกี่ยวข้องกับการติดต่อระหว่างท่านกับเรา หรือเมื่อท่านใช้ผลิตภัณฑ์และบริการของเรา"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "4 เมื่อท่านติดต่อกับเรา เช่น ผ่านทางโทรศัพท์ (ซึ่งจะได้รับการบันทึก) จดหมาย แฟกซ์ การประชุม การติดต่าผ่านแพลตฟอร์มสื่อทางสังคม และอีเมล"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "5 เมื่อท่านใช้บริการทางอิเล็กทรอนิกส์ หรือใช้บริการเว็บไซต์ของเรา ซึ่งรวมถึงแต่ไม่จำกัดเพียง การใช้ผ่านคุกกี้ ซึ่งเราอาจปรับใช้เมื่อท่านได้เข้าถึงเว็บไซต์"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("6 เมื่อท่านดำเนินธุรกรรมผ่านบริการของเรา")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v("7 เมื่อท่านแสดงความคิดเห็นหรือส่งคำร้องเรียนแก่เรา")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "8 เมื่อท่านลงทะเบียน เข้าทำสัญญา เข้าร่วมในการแข่งขัน และ/หรือกิจกรรมส่งเสริมการขายซึ่งรวมถึงกิจกรรมส่งเสริมการขายร่วมกับหุ้นส่วนหรือบริษัทในกลุ่มของเรา"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "9 เมื่อท่านใช้หรือร้องขอการใช้บริการที่เกี่ยวข้องกับผู้ให้บริการภายนอกของเรา เช่น การชำระเงิน บริการด้านโลจิสติกส์ เป็นต้น"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "10 เมื่อท่านเข้าเยี่ยมชมหรือใช้เว็บไซต์และแอปพลิเคชั่นของหุ้นส่วนหรือบริษัทในกลุ่มของเรา"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "11 เมื่อท่านเข้าเยี่ยมชมหรือใช้เว็บไซต์และแอปพลิเคชั่นของบุคคลภายนอกที่เกี่ยวข้องกับบริการของเรา"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "12 เมื่อท่านติดตั้งแอปพลิเคชั่นบนคอมพิวเตอร์ โทรศัพท์ หรืออุปกรณ์อื่นๆ เพื่อเข้าถึงบริการของเรา"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "13 เมื่อท่านเชื่อมต่อบัญชีของท่านกับเว็บไซต์หรือแอปพลิเคชั่นของบุคคลภายนอก"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block_3" }, [
          _vm._v(
            "14 เมื่อท่านส่งข้อมูลส่วนบุคคลของท่านให้แก่เราด้วยเหตุผลใดก็ตาม"
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_2" }, [
        _vm._v("การประมวลผลข้อมูลส่วนบุคคล")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_5" }, [_vm._v("การประมวลผลข้อมูล")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "รายละเอียดปรากฏตามนโยบายคุ้มครองข้อมูลส่วนบุคคล หัวข้อ “การประมวลผลข้อมูลส่วนบุคคล”"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_5" }, [
        _vm._v("การเก็บรักษาข้อมูลส่วนบุคคล")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "รายละเอียดปรากฏตามนโยบายคุ้มครองข้อมูลส่วนบุคคล หัวข้อ “การเก็บรักษาข้อมูลส่วนบุคคล”"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "block_5" }, [_vm._v("สิทธิของเจ้าของข้อมูล")]),
      _vm._v(" "),
      _c("p", { staticClass: "block_1" }, [
        _vm._v(
          "รายละเอียดปรากฏตามนโยบายคุ้มครองข้อมูลส่วนบุคคล เรื่อง “สิทธิของเจ้าของข้อมูล”"
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b054330e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b054330e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/PrivacyTh.vue
// module id = 1499
// module chunks = 0